import {getBottomCalendarLayerTmpl,} from "./templates/html.template";
import Popup from "./base/Popup";
import {getFormatZero} from "../utils/util";
import { isA11yCheckVersion, isA11ySetAttr, isPopupMakeCloseButtonOne } from "../functions/a11y.ui";
/**
 * PopupCalendar
 */
/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_picker.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_picker.html)
* Calendar
*/
class PopupCalendar extends Popup {
    defaults = {
        type: 'calendar',
        curYear:'',
        curMonth:'',
        curDay:'',
        beforeYear:'',
        beforeMonth:'',
        beforeDay:'',
        selectChk: false,
    };
    $datepicker;
    customDatepickerOptions = {};
    availableDates = [];
    closeCallback = () => {};
    openCallback = () => {};
    isA11yObj = {
        isClickChecked:false, //a11y접근성 클릭여부를 통해 다음 / 이전 분기처리 필요로 사용
        titleTargetFocus: null, //클릭한 버튼의 년 월 계산 -> 이전, 다음 체크해서 string<'title', 'prev', 'next'> 3가지 타입 지정
        isOpenTarget: null,
    };

    popupCalendarBtn = null;

    constructor(el, options, selector) {
        super('PopupCalendar', el);
        this.selector = selector;
        this.init(el, options, selector);
    }

    init(el, options, selector) {
        this.popupInit(el, options, selector);
        this.detachEvents();
        this.attachEvents();

        /*! s: FETASK-a11y page Calendar v.1.0.0 */
        if(isA11yCheckVersion()){
            this.isA11yCalendarInit();
        }
        /*! e: FETASK-a11y page Calendar v.1.0.0 */
    }
    /**
     * ui-calendar 어트리뷰트값 변경시 실행
     * @example 
     * $('.ui-calendar').data('ui').update();
     */
    update(datepickerOptions = {}) {
        const getpageCalendar = this.$el.attr('page-calendar');
        this.detachPopupEvents();

        if (getpageCalendar == undefined && !this.$popup) {
            return;
        }
        //console.log('데이트피커 타겟 = ',this.defaults.pickerSelector);
        if (this.defaults.pickerSelector != undefined) {
            this.minMaxDateSetting()
        }

        if (getpageCalendar != undefined) this.$el.attr('data-id', this.uiId);

        const defaultDate = this.makeDateValue(this.$el.val());
        let customDate = this.$el.attr('custom-date');
        let resDate;
        if(defaultDate.length > 0){
            resDate = defaultDate;
        }else if(defaultDate.length == 0 && customDate != undefined){
            resDate = customDate;
        }

        const onSelect = (inp,obj) => {
            // console.log('onSelect')
            this.defaults.selectChk = true;
            this.defaults.curYear= this.$datepicker.val().split('.')[0];
            this.defaults.curMonth= Number(this.$datepicker.val().split('.')[1]);
            this.defaults.curDay= Number(this.$datepicker.val().split('.')[2]);
            this.defaults.beforeYear= this.defaults.curYear
            this.defaults.beforeMonth= this.defaults.curMonth
            this.defaults.beforeDay= this.defaults.curDay
            setTimeout(()=>{
                if ($(obj.dpDiv).find('.jui-datepicker-title [caln-event]').length == 0) {
                    $(obj.dpDiv).find('.jui-datepicker-title').append('<div caln-event tabindex="-1" aria-hidden="true"></div>')
                }
            },10);
            if(getpageCalendar == undefined) this.$popup.find('.btn-group button .txt').text(`${this.defaults.curYear}년 ${this.defaults.curMonth}월 ${this.defaults.curDay}일 선택`)

            const isA11yCheck = isA11yCheckVersion();
            if(isA11yCheck){
                that.isA11yObj.isClickChecked = false; //day(요일) 영역 클릭시 false
            }
        }

        /*! s: FETASK-a11y page Calendar v.1.0.0 */
        const isA11yCheck = isA11yCheckVersion();
        const isA11yOption = {}; //calendar에 a11y체크해서 옵션 추가

        if(isA11yCheck){
            this.isA11yObj.isOpenTarget = this.$el;
        }
        const onUpdateDatepicker = (inst) => {
            /** 캘린더 데이터 업데이트 후 캘린더가 전체 새로 그려지기때문에 업데이트 후에 동작을 실행해서 focus가게 로직 추가 */
            const { dpDiv, drawMonth } = inst;
            if(!this.isA11yObj.isClickChecked){

                const activeEle = dpDiv.find('.jui-state-active');
                if(activeEle[0]){
                    //선택된 곳 찾아서 focus
                    setTimeout(() => {
                        activeEle.focus();
                    },500);
                }else{
                    //체크된거 없을시 선택가능한 맨 처음위치로 focus;
                    const firstEle = dpDiv.find(`.jui-datepicker-calendar [data-month=${drawMonth}]`) || dpDiv.find('a[data-date="1"]');
    
                    if(firstEle?.length && firstEle[0]?.children[0]){
                        setTimeout(() => {
                            firstEle[0]?.children[0]?.focus();
                        },500);
                    }
                }
            }

            setTimeout(() => {
                if(isA11yCheck){
                    this.isA11yCalendar();
                    this.isA11yCalendarAcess(inst);
                }
            },100);
        }
        
        //isA11yOption.onUpdateDatepicker = onUpdateDatepicker; // 241203 onUpdateDatepicker 로만 실행

        /*! e: FETASK-a11y page Calendar v.1.0.0 */
        const beforeShow = (inp, obj) => {
            // 데이터피커 테스트
            if (this.defaults.pickerSelector != undefined) {
                let target = (getpageCalendar == undefined) ? this.$popup.find('.popup-content') : this.$el;
                target.find('.jui-datepicker-title').append('<div caln-event tabindex="-1" aria-hidden="true"></div>');
            }
            //console.log('before', obj.selectedYear, obj.selectedMonth+1)
            this.defaults.curYear = obj.selectedYear;
            this.defaults.curMonth = obj.selectedMonth+1;
            this.defaults.curDay = obj.selectedDay;
            this.defaults.beforeYear = obj.selectedYear;
            this.defaults.beforeMonth = obj.selectedMonth+1;
            this.defaults.beforeDay = obj.selectedDay;
            //console.log('저기',this.defaults.curYear, this.defaults.curMonth,this.defaults.curDay,this.defaults.beforeYear,this.defaults.beforeMonth,this.defaults.beforeDay)
            const { dpDiv } = obj;
            if(getpageCalendar == undefined) {
                if (!this.$popup.find('.popup-group').find('.btn-group').length>0) {
                    this.$popup.find('.popup-group').append(`<div class="popup-footer"><div class="btn-group"><div class="btn-group"><button type="button" class="btn-lv01 primary1 ui-btnConfirm"><span class="txt"></span></button></div></div></div>`)
                }
                if (this.$popup.find('.popup-footer .ui-btnConfirm .txt').length > 0) {
                    this.$popup.find('.popup-footer .ui-btnConfirm .txt').text(`${customDate != undefined || this.$el.val() != '' ? `${this.defaults.curYear}년 ${this.defaults.curMonth}월 ${this.defaults.curDay}일 선택` : `${this.$el.attr('data-calnbtn-text') == undefined ? '선택' : this.$el.attr('data-calnbtn-text')}`}`)
                }
            }
            
            if (this.defaults.selectDef === 'unselected') {
                const that = this;
                $(document).off('click.calReset').on('click.calReset', '.jui-datepicker-next, .jui-datepicker-prev', function(e){
                    if (that.$el.val() === undefined || that.$el.val() === '') {
                        $(inp).find('.jui-state-active').removeClass('jui-state-active');
                        that.$datepicker.val('');
                    }
                })
                if (this.$el.val() === undefined || this.$el.val() === '') {
                    setTimeout(() => {
                        $(this.$datepicker).find('.jui-state-active').removeClass('jui-state-active');
                        this.$datepicker.val('');
                    }, 100)
                }
            }

            /*! s: FETASK-a11y page Calendar v.1.0.0 */
            if(isA11yCheck){
                const activeEle = dpDiv.find('.jui-state-active');
    
                if(activeEle[0]){
                    //선택된 곳 찾아서 강제로focus
                    let count = 0;
                    let interval = setInterval(() => {
                        if(count >= 20){
                            clearInterval(interval);
                        }
                        
                        activeEle.focus();
                        count++;
                    },100);
                }
            }
            /*! e: FETASK-a11y page Calendar v.1.0.0 */
        }
        ////console.log('defaultDate = '+defaultDate+' , customDate = '+customDate);
        const that = this;
        // 데이터피커 테스트
        let _changeYearOpt = false
        let _changeMonthOpt = false
        if (that.defaults.pickerSelector) {
            _changeYearOpt = true
            _changeMonthOpt = true
        }
        let _datepicker = (getpageCalendar == undefined) ? this.$popup.find('.ui-datepicker') : this.$el.find('.ui-datepicker');

        this.$datepicker = _datepicker.datepicker('destroy').datepicker({
            defaultDate : resDate,
            beforeShow,
            changeYear:_changeYearOpt, // 데이터피커 테스트
            changeMonth:_changeMonthOpt, // 데이터피커 테스트
            maxDate:that.defaults.maxDate,
            minDate:that.defaults.minDate,
            monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'], 
            onChangeMonthYear: function(year,month,element){ // 데이터피커 테스트
                if (that.defaults.pickerSelector != undefined) {
                    that.defaults.selectChk = false;
                    that.defaults.curYear = element.drawYear,
                    that.defaults.curMonth = element.drawMonth+1
                    setTimeout(()=>{
                        //$(element.input).find('[data-type="dateSpinner"]').data('ui').setValues([element.drawYear, element.drawMonth+1])
                        if ($(element.dpDiv).find('.jui-datepicker-title [caln-event]').length == 0) {
                            $(element.input).find('[data-type="dateSpinner"]').attr('data-title', `${element.drawYear}년 ${element.drawMonth+1}월`);
                            $(element.dpDiv).find('.jui-datepicker-title').append('<div caln-event tabindex="-1" aria-hidden="true"></div>');
                        }
                        if(getpageCalendar != undefined) $(element.dpDiv).closest('.ui-calendar').find('[data-type="dateSpinner"]').attr('data-title', `${element.drawYear}년 ${element.drawMonth+1}월`);
                    },2)
                }

                /*! s: FETASK-a11y page Calendar v.1.0.0 */
                if(isA11yCheck){
                    //년 , 이전 월, 이전 달 변경 체크 click이벤트보다 먼저 발생되서 setTimeout으로 뒤로 실행되게 추가하여 focus초점 시점 조정
                    const { currentMonth, currentYear, drawMonth, drawYear } = element;
                    
                    const currentDate = new Date(`${currentYear}-${currentMonth}`); 
                    const drawDate = new Date(`${drawYear}-${drawMonth}`);

                    that.isA11yObj.isClickChecked = true; //년도 월 이전/다음 클릭시 true로 설정해서 focus안가게 막기

                    setTimeout(() => {
                        if(!that.isA11yObj.isClickChecked){
                            if(currentDate < drawDate){
                                $('.jui-datepicker-next:not(.jui-state-disabled)').attr('tabindex','0').focus()
                            }else{
                                $('.jui-datepicker-prev:not(.jui-state-disabled)').attr('tabindex','0').focus();
                            }
                        }else{
                            const focusType = that.isA11yObj.titleTargetFocus,
                            focusTarget = (getpageCalendar != undefined) ? that.$datepicker : that.$popup;
                            if(focusType === 'title'){
                                //캘린더 스크롤 발생시 리랜더 되면서 focus초점 사라지는 버그 발생, 이벤트 객체로 해결 불가하여 비동기로 처리
                                setTimeout(() => {
                                    focusTarget.find('.jui-datepicker-title').focus();
                                },200);
                            }else if(focusType === 'prev'){
                                focusTarget.find('.jui-datepicker-prev:not(.jui-state-disabled)').attr('tabindex','0').focus();
                            }else if(focusType === 'next'){
                                focusTarget.find('.jui-datepicker-next:not(.jui-state-disabled)').attr('tabindex','0').focus();
                            }
                        }
                    },500);
                };
                /*! e: FETASK-a11y page Calendar v.1.0.0 */
            },
            onSelect,
            onUpdateDatepicker, // 241202 추가
            ...this.customDatepickerOptions,
            /*! s: FETASK-a11y page Calendar v.1.0.0 */
            ...{...isA11yCheck && isA11yOption},
            /*! e: FETASK-a11y page Calendar v.1.0.0 */
        });
 
        /*! s: FETASK-a11y page Calendar v.1.0.0 */
        if(isA11yCheck){

            

            // 데이터피커 클릭해서 
            this.$datepicker.on('click',(e) => {
                const isDirection = e.target.innerText;
                if(isDirection === '이전달'){
                    that.isA11yObj.titleTargetFocus = 'prev';
                }else if(isDirection === '다음달'){
                    that.isA11yObj.titleTargetFocus = 'next';
                }else{
                    that.isA11yObj.titleTargetFocus = 'title';
                }

                setTimeout(()=>{
                    const otherMonthEles = this.$datepicker.find('.jui-datepicker-other-month'),
                    stateDisabled = this.$datepicker.find('.jui-state-disabled'),
                    datepickerNp = this.$datepicker.find('.jui-datepicker-prev, .jui-datepicker-next');
                    if(datepickerNp?.length){
                        datepickerNp.attr('role','button');
                    }
                    if(stateDisabled?.length){
                        stateDisabled.attr({'aria-hidden':'false', 'aria-disabled':'true'});
                    }
                    if(otherMonthEles?.length){
                        otherMonthEles.attr({'aria-hidden':'true', 'aria-disabled':'true'});
                        otherMonthEles.removeAttr('role');
                        otherMonthEles.removeAttr('tabindex');
                        otherMonthEles.children().attr('aria-disabled','true');
                        otherMonthEles.children().removeAttr('role');
                        otherMonthEles.children().removeAttr('tabindex');
                    }
                    this.$datepicker.find('td:not(.jui-datepicker-other-month) a').attr('role','button');
                },100)
            });
        }
        /*! e: FETASK-a11y page Calendar v.1.0.0 */

        this.setPageCalendarData();

        /*! s: FETASK-a11y page Calendar v.1.0.0 */
        isA11yCheck && this.isA11yCalendar();
        /*! e: FETASK-a11y page Calendar v.1.0.0 */

        // this.openMotion();
    }

    setPageCalendarData(){
        const getpageCalendar = this.$el.attr('page-calendar');
        this.setCustomCalendar();
        this.attachPopupEvents();
        if(getpageCalendar != undefined) frontUI.refreshUI();
    }

    setCustomCalendar(){
        const getpageCalendar = this.$el.attr('page-calendar');
        const chkTarget = (getpageCalendar != undefined) ? this.$el : this.$popup;
        const This = this;
        let customDate = this.$el.attr('custom-date');

        // console.log('데이트피커 타겟 = ',this.defaults.pickerSelector);
        // if (this.defaults.pickerSelector != undefined) {
        //     this.minMaxDateSetting()
        // }

        if (chkTarget.find('[data-caln-selector]').length < 1) {
            if (this.defaults.pickerSelector != undefined) {
                appendCustomDate();
            }
        }else{
            // if(getpageCalendar != undefined) {
            //     if (this.defaults.pickerSelector != undefined) {
            //         if(chkTarget.find('[data-caln-selector]').length > 0) chkTarget.find('[data-caln-selector]').remove();
            //         appendCustomDate();
            //     }
            // }
        }

        function appendCustomDate(){
            if (customDate != undefined) {
                This.defaults.curYear= customDate.split('.')[0];
                This.defaults.curMonth= Number(customDate.split('.')[1]);
                This.defaults.curDay= Number(customDate.split('.')[2]);
            }
            console.log(This.$el.attr('data-title'), )
            chkTarget.attr('spinnertype', '');
            const _minDate = This.defaults.minDate.replace(/[.]/gi, '-');
            const _maxDate = This.defaults.maxDate.replace(/[.]/gi, '-');
            const content = (getpageCalendar != undefined) ? chkTarget : chkTarget.find('.popup-content');
            content.append(`<div class="input-arrow-group ui-input"
            data-caln-selector="${This.defaults.pickerSelector}"
            data-type="dateSpinner" data-case="calendar"
            data-date="YYMM" data-from-date="${_minDate}"
            data-to-date="${_maxDate}"
            ${This.$el.attr('data-title') == undefined ? `data-title="${This.defaults.curYear}년 ${This.defaults.curMonth}월"` 
            : `data-title="${This.$el.attr('data-title')}" data-sub-title="${This.defaults.curYear}년 ${This.defaults.curMonth}월"`}
            data-slide-view="5"
            ><input type="text"  readonly="readonly" /><i class="ico-arrow-open" aria-hidden="true"></i></div>`);
            This.stateDisabled();
            This.attachEvents();
        }
    }

    setOption(datepickerOptions = {}) {
        this.customDatepickerOptions = datepickerOptions;
    }

    stateDisabled(){
        setTimeout(()=>{
            //console.log('stateDisabled !!');
            const getpageCalendar = this.$el.attr('page-calendar');
            if(getpageCalendar != undefined){
                const chkTarget = this.$el;
                const disabledClass = 'jui-state-disabled';
                setDisabled('prev');
                setDisabled('next');
                function setDisabled(type){
                    if(chkTarget.find(`.jui-datepicker-${type}`).hasClass(disabledClass)) {
                        chkTarget.prev('.ceo-cal-btn').find(`.chinge-month-${type}`).addClass(disabledClass).css({'opacity':'.5','pointer-events':'none'}).attr('tabindex','-1');
                    }else{
                        chkTarget.prev('.ceo-cal-btn').find(`.chinge-month-${type}`).removeClass(disabledClass).css({'opacity':'1','pointer-events':'auto'}).attr('tabindex','0');
                    }
                }
            }
        },200);
    }
    /**
     * 캘린더 팝업이 열린후 prev, next 버튼을 강제로 클릭하는 이벤트
     * @param {String}  type  'next' or 'prev'
     * @example 
     * $('.ui-calendar').data('ui').calendarChangeMonth('prev');
     */
    calendarChangeMonth(type=''){
        if(this.$datepicker){
            this.$datepicker.find(`.jui-datepicker-${type}`).trigger('click').attr('tabindex','0').focus();
            this.$datepicker.closest('.page-inner-scroll').stop().animate({scrollTop:0},0);
            this.stateDisabled();
        }
    }
    /**
     * (개발에서 로직 만들시 불필요) 리스트 데이터 생성후 캘린더에 데이터 있는 날짜만 활성화 ** 리스트 생성완료 시점 적용 비동기 호출 **
     * @example 
     * $('.ui-calendar').data('ui').calendarGetDateShow();
     */
    calendarGetDateShow(){
        setTimeout(()=>{
            const This = this.$datepicker,
            hideDateAttr = {'opacity':'.3'}, 
            showDateAttr = {'opacity':'1'};
            let customDate = this.$el.attr('custom-date');
            This.find('td').css(hideDateAttr).addClass('pointer-none');
            console.log(`(${$('.jui-datepicker-month > option:selected').text()} 생성된 달력 데이터)-------------------------------------------------------`);
            $(`[data-calendar-index]`).each(function(i){
                const setDate = $(this).attr('data-calendar-index'), dateInner = This.find(`td:not(.jui-datepicker-other-month) [data-date="${setDate}"]`);
                dateInner.parent().css(showDateAttr).removeClass('pointer-none');
                console.log(`데이터 인덱스 = ${setDate} `);
            });
            // this.setPageCalendarData();
            this.stateDisabled();
            if(customDate != undefined) {
                this.calendarClickScroll(Number(customDate.split('.')[2]));
                console.log('시작시 스크롤 될 날짜 = ', Number(customDate.split('.')[2]))
            }
            console.log('페이지 캘린더 셋팅완료!');
        },150);
    }
    calendarClickScroll(setScrollDate){
        setTimeout(()=>{
            const scrollTarget = this.$el.closest('.page-inner-scroll'),
            topGab = scrollTarget.find('.component-header').innerHeight() + this.$el.closest('.component-ceo-calendar').innerHeight() + 50,
            dateBtns = this.$datepicker.find('td:not(.jui-datepicker-other-month)'),
            deteBtnTarget = this.$datepicker.find('td:not(.jui-datepicker-other-month) .jui-state-default');
            let chkDate = null, scrollSpeed = 500, scrollGab = this.$el.data('scrollGab');
            (scrollGab != undefined) ? scrollGab : 0;
            chkDate = null;
            
            if(setScrollDate && setScrollDate != undefined) {
                const setObj = $(`[data-calendar-index="${setScrollDate}"]`);
                if(setObj && setObj.length > 0) {
                    deteBtnTarget.removeClass('jui-state-active');
                    this.$datepicker.find(`[data-date="${setScrollDate}"]`).addClass('jui-state-active').focus();
                    scrollMove(scrollPos(setObj));
                }
            }
            
            dateBtns.off(`click`).on(`click`, (e)=>{
                e.preventDefault();
                const target = $(e.currentTarget).find('.jui-state-default'),
                firstDate = $(`[data-calendar-index]:first-child`).data('calendarIndex'),
                setDate = target.data('date'),
                setObj = $(`[data-calendar-index="${setDate}"]`);
                if(!target.parent().hasClass('pointer-none')){
                    deteBtnTarget.removeClass('jui-state-active');
                    target.addClass('jui-state-active').focus();
                }
                if(chkDate != setDate && setObj.length > 0) {
                    (setObj.data('calendarIndex') == firstDate) ? scrollMove(0) :
                    scrollMove(scrollPos(setObj));
                }
                chkDate = setDate;
                return false;
            });

            function scrollPos(obj){
                const pos = (scrollTarget.scrollTop() + obj.offset().top - topGab) - scrollGab;
                return pos;
            }

            function scrollMove(value) {
                scrollTarget.stop().animate({scrollTop:value},scrollSpeed);
            }
        },200);
    }
    
    render() {
        const getpageCalendar = this.$el.attr('page-calendar');
        if (!this.$popup) {
            // console.log(this)
            // let _title; // 240205 : 캘린더 팝업 전체 공통 타이틀 추가
            // if (this.defaults.type == 'calendar') {
            //     _title = this.$el.attr('data-title') == undefined ? '날짜를 선택해주세요' : this.$el.attr('data-title'); 
            // }
            this.$popup = $(getBottomCalendarLayerTmpl(this.defaults.type, this.$el.attr('data-title'), this.$el.attr('data-sub-title')));
            this.$popupContainer.append(this.$popup);
            this.$popup.attr('data-id', this.uiId);
            if(getpageCalendar != undefined) this.$popup.addClass('hide-popup');
            this.update();
        }
        this.openMotion();

        console.log('#!#!@#!#!@#!#!@')
    }

    openMotion() {
        this.openCommonMotion({
            cancelMotion: false,
            callback: () => {
            }
        });
        if (this.openCallback && $.isFunction(this.openCallback)) {
            this.openCallback();
        }
    }

    closeMotion(type) {
        if (type == 'calnDimm') {
            if (this.$el.val() == '') {
                this.$el.closest('.ui-input').removeClass('active')
                this.$el.focus();
            }
        }
        this.closeCommonMotion({
                cancelMotion: false,
                callback: () => {
                    this.$el.next('button').length && this.$el.next('button').focus();
                }
            }
        );
        this.a11yPopupInit();
    }
    onCloseCallback(fn){
        $(this.$el).each((idx, ui) => {
            const uiInstance = $(ui).data('ui');

            uiInstance.setCloseCallback(fn);
        });
    }
    /**
     * close 콜백
     * @param {function} fn  콜백
     * @example 
     * $('.ui-calendar').data('ui').setCloseCallback(function(){});
     */
    setCloseCallback(fn){
        this.closeCallback = fn;
    }

    /**
     * open 콜백
     * @param {function} fn  콜백
     * @example 
     * $('.ui-calendar').data('ui').setOpenCallback(function(){});
     */
    setOpenCallback(fn){ // CHPFMTASK-911 
        this.openCallback = fn;
    }
    makeDateValue(val) {
        let _val = val;
        if (!_val.includes('.') && _val != '') {
            _val = _val.substr(0,4)+'.'+_val.substr(4,2)+'.'+_val.substr(6,2)
        }
        return _val;
    }
    open(fn = () => {
    }) {
        fn();

        setTimeout(() => {
            this.render();
        }, 0);
       
    }

    close(fn = () => {
    }) {
        fn();

        this.closeMotion();
    }

    attachEvents() {
        const getpageCalendar = this.$el.attr('page-calendar');
        if(getpageCalendar == undefined){
            this.$el.off(`click${this.eventId}`).on(`click${this.eventId}`, (e) => {
                if (this.$el.attr('data-prevent-event') == 'false'){ // 캘린더 회색 day 클릭 가능 // CHPFMTASK-911
                    setTimeout(() => {
                        this.$popup[0].classList.add('preventClickFalse')
                    }, 0);
                    
                }
                if($(e.currentTarget).closest('.hide-btn').length === 0) {
                    this.render();
                }
                setTimeout(() => {
                    this.update();
                }, 0);
            });
    
            this.$el.next('.btn_cal').on(`click${this.eventId}`, (e) => {
                this.render();
            });
        }
        
        // $(document).off('click.confirmClick').on('click.confirmClick', '.popup-footer .ui-btnConfirm', (e) => {
        //     if ($(e.currentTarget).closest('[spinnertype]').length > 0) {
                
        //     }
            
        // })
    }

    detachEvents() {
        this.$el.off(this.eventId);
        this.$el.next('.btn_cal').off(this.eventId);
    }

    attachPopupEvents() {
        const getpageCalendar = this.$el.attr('page-calendar');
    
        if(getpageCalendar == undefined){
            this.$popup.on(`click${this.eventId}`, '.popup-footer button', (e) => {
                e.preventDefault();
                //console.log('컨펌 클릭','before:',this.defaults.beforeYear, this.defaults.beforeMonth,this.defaults.beforeDay, 'currrent',this.defaults.curYear,this.defaults.curMonth,this.defaults.curDay)
                if ($(e.currentTarget).find('.txt').text() != "선택") {
                    if (this.defaults.selectChk == false) {
                        //this.$el.val(`${this.defaults.beforeYear}.${this.defaults.beforeMonth}.${this.defaults.beforeDay}`);
                        //this.$el.attr('value',`${this.defaults.beforeYear}.${this.defaults.beforeMonth}.${this.defaults.beforeDay}`)
                        //this.$el.attr('custom-date',`${this.defaults.beforeYear}.${this.defaults.beforeMonth}.${this.defaults.beforeDay}`)
                        this.$el.val(`${this.defaults.beforeYear}.${getFormatZero(this.defaults.beforeMonth)}.${getFormatZero(this.defaults.beforeDay)}`);
                        this.$el.attr('value',`${this.defaults.beforeYear}.${getFormatZero(this.defaults.beforeMonth)}.${getFormatZero(this.defaults.beforeDay)}`)
                        this.$el.attr('custom-date',`${this.defaults.beforeYear}.${getFormatZero(this.defaults.beforeMonth)}.${getFormatZero(this.defaults.beforeDay)}`)
                    } else {
                        //this.$el.val(`${this.defaults.curYear}.${this.defaults.curMonth}.${this.defaults.curDay}`);
                        //this.$el.attr('value',`${this.defaults.curYear}.${this.defaults.curMonth}.${this.defaults.curDay}`)
                        //this.$el.attr('custom-date',`${this.defaults.curYear}.${this.defaults.curMonth}.${this.defaults.curDay}`)
                        this.$el.val(`${this.defaults.curYear}.${getFormatZero(this.defaults.curMonth)}.${getFormatZero(this.defaults.curDay)}`);
                        this.$el.attr('value',`${this.defaults.curYear}.${getFormatZero(this.defaults.curMonth)}.${getFormatZero(this.defaults.curDay)}`)
                        this.$el.attr('custom-date',`${this.defaults.curYear}.${getFormatZero(this.defaults.curMonth)}.${getFormatZero(this.defaults.curDay)}`)
                    }
                }
                this.closeCallback(this.makeDateValue(this.$el.val()));
                this.closeMotion();
                if(typeof changeDate !== "undefined"){
                    changeDate(this.$datepicker.val());
                }
                //Popup.resetAllPopup()
                // //console.log('bottom', this.$datepicker)
                // this.$el.val(this.$datepicker.val());
                // this.closeCallback(this.makeDateValue(this.$el.val()));
                // this.closeMotion('closeButton');
                // if(typeof changeDate !== "undefined"){
                //     changeDate(this.$datepicker.val());
                // }
            });

            this.$popup.on(`click${this.eventId}`, (e) => {
                e.preventDefault();

                // CHPFMTASK-2039 ui-calendar 모션끝났을때만 실행
                if(this.$popup.css('transform') === 'none'){
                    if (e.target === e.currentTarget) {
                        this.closeMotion('calnDimm');
                    }
                }
            });

            // 닫기 버튼 없어서 일단 주석
            // this.$popup.on(`click${this.eventId}`, '.btn-close-popup', (e) => {
            //     e.preventDefault();

            //     this.closeMotion();
            // });

            this.$dimm.on(`click${this.eventId}`, (e) => {
                e.preventDefault();
                this.closeMotion('calnDimm');
            });

            /*! s: FETASK-a11y 닫기버튼 클릭시 해당 input 포커스 v.1.0.0 */
            if(isA11yCheckVersion()){
                this.$popup.on(`click${this.eventId}`, '.ui-btnConfirm, .close-btn', (e) => {
                    e.preventDefault();
                    
                    $(this.$popup)?.data('ui')?.close(); //확인버튼 클릭시 딤 안닫히는 현상 수정

                    this.isA11yFocusMove();
                });
            }
            /*! e: FETASK-a11y 닫기버튼 클릭시 해당 input 포커스 v.1.0.0 */
            
        }

        const chkTarget = (getpageCalendar != undefined) ? this.$el : this.$popup;
        // 데이터피커 테스트
        chkTarget.off('click.calnEvent').on('click.calnEvent', '[caln-event]', (e) => {
            //console.log('caln 클릭',this.defaults.beforeYear, this.defaults.beforeMonth,this.defaults.beforeDay)
            
            this.openPageSpinner(getpageCalendar, $(e.currentTarget));
           
            /*! s: FETASK-a11y 캘린더 2중팝업 v.1.0.0 */
            if(isA11yCheckVersion()){
                const calnEventBtn = document?.querySelector('.jui-datepicker-title');
                calnEventBtn?.removeAttribute('tabindex','-1');
            }
            /*! e: FETASK-a11y 캘린더 2중팝업 v.1.0.0 */
        });
    }
    
    // $('.ui-calendar').off('click.calnEvent');
    // openPageSpinner($('[page-calendar]').attr('page-calendar'), $('[caln-event]'));

    openPageSpinner(getattr, target){
        // console.log(target)
        const parentTarget = (getattr != undefined) ? '[page-calendar]' : '.ui-popup';
        this.defaults.selectChk = false;
        // console.log('년도 => ',Number(this.defaults.curYear), '월 = >', Number(this.defaults.curMonth));
        // console.log(target.closest(parentTarget).find('[data-type="dateSpinner"]').data('ui'))
        target.closest(parentTarget).find('[data-type="dateSpinner"]').data('ui').setValues([Number(this.defaults.curYear), Number(this.defaults.curMonth)])
        setTimeout(()=>{
            target.closest(parentTarget).find('[data-type="dateSpinner"] input').trigger('click');
            this.popupCalendarBtn = target.closest(parentTarget).find('[data-type="dateSpinner"]').data('ui').$popup.find('.ui-btnConfirm');
            target.closest(parentTarget).find('[data-type="dateSpinner"]').data('ui').popupTitle({
                spinner:`${this.defaults.curYear}년 ${this.defaults.curMonth}월`,
                title:this.$el.attr('data-title'),
                subTitle: this.$el.attr('data-sub-title')
            });
        },10);
    }

    closeDateSpinner(){
        this.popupCalendarBtn && this.popupCalendarBtn.trigger('click');
    }
    
    beforeShowDay(stringDate) {
        $(this.selector).each((idx, ui) => {
            const uiInstance = $(ui).data('ui');

            uiInstance.setBeforeShowDay(stringDate);
        });
    }
    setButtonText (){

    }
    setBeforeShowDay(stringDate) {
        this.availableDates = stringDate;

        function available(date) {
            let thismonth = date.getMonth()+1;
            let thisday = date.getDate();
    
            if (thismonth < 10) {
                thismonth = "0" + thismonth;
            }
    
            if (thisday < 10) {
                thisday = "0" + thisday;
            }
    
            let ymd = date.getFullYear() + "." + thismonth + "." + thisday;
            if ($.inArray(ymd, stringDate) >= 0) {
                return [true, "", ""];
            } else {
                return [false, "", ""];
            }
        }
        
        this.setOption({
            beforeShowDay: available
        });
    }

    detachPopupEvents() {
        this.$popup && this.$popup.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
        this.detachPopupEvents();
    }

    minMaxDateSetting(){
        const _date = new Date
        const _year = _date.getFullYear();
        const _month = _date.getMonth()+1;
        const _days = _date.getDate();
        //console.log('year:',_year, 'month:',_month, 'days:', _days)
        if (this.$el.attr('data-min-date') == undefined) {
            this.defaults.minDate = `${_year-5}.${_month}.${_days}`
        } else {
            this.defaults.minDate = this.$el.attr('data-min-date')
        }
        if (this.$el.attr('data-max-date') == undefined) {
            this.defaults.maxDate = `${_year+5}.${_month}.${_days}`
        } else {
            this.defaults.maxDate = this.$el.attr('data-max-date')
        }
        //console.log('set',this.defaults.minDate,this.defaults.maxDate )
    }
    /**
     * 한자릿수 숫자를 두자리 문자로 만들어준다.
     * @param v {number}    수
     * @returns {string}    ex) 9 => 09
     */
    static getFormatZero(v){
        return getFormatZero(v);
    }

    /*! s: FETASK-a11y page Calendar v.1.0.0 */
    isA11yCalendar(){
        if(isA11yCheckVersion()){
            const getpageCalendar = this.$el.attr('page-calendar');
            if(this?.$popup){
                if(getpageCalendar == undefined){
                    const curPopup = this.$popup[0];
                    const calendarHead = curPopup.querySelector('.jui-datepicker-header');
                    const calendarTit = curPopup.querySelector('.jui-datepicker-title');
            
                    curPopup.setAttribute('aria-hidden','false');
                    calendarHead.insertBefore(calendarTit, calendarHead.firstChild);
                }
                //팝업 닫기버튼 추가
                // isPopupMakeCloseButtonOne(this.$popup);
            }
        }
    }
    a11yPopupInit(){
        requestAnimationFrame(async () => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행
            if(isA11yCheck){
                const popupEles = document.querySelectorAll('.ui-popup');
                const activeSlidesEle = document.querySelector('.activeSlide') //activeSlide

                this.$popup[0].classList.remove('activePopup');

                if(!Popup.arrPrePopup.length){// activePopup 0개일때
                    this.$popup[0].removeAttribute('tabindex');

                    activeSlidesEle?.setAttribute('aria-hidden', 'false');
                    activeSlidesEle?.setAttribute('tabindex', '0');

                    this.$popup[0].classList.remove('activePopup');
                }else{
                    //맨 마지막기준 activePopup 삭제 후 제일 마지막에 포커스 모든 팝업 tab포커스 막기

                    const activeLastPopupEle = document.querySelectorAll('.activePopup');
                    const lastActiveNum = activeLastPopupEle?.length - 1;


                    if(lastActiveNum > -1){
                        const delay = new Promise((resolve) => setTimeout(resolve, 500));

                        await delay; //닫기 실행후 바로 실행되면 focus안되는 이슈 발생으로 버그 방지

                        await activeLastPopupEle[lastActiveNum].setAttribute('aria-hidden', 'false');
                        await activeLastPopupEle[lastActiveNum].setAttribute('tabindex', '0');
                    }
                }

                this.isA11yFocusMove();
            }
        });
    }
    /*! e: FETASK-a11y page Calendar v.1.0.0 */
    
    /*! s: FETASK-a11y page Calendar v.1.0.0 */
    isA11yCalendarAcess(inst){
        //캘린더 접근성 로직
        try {
            const { dpDiv, selectedYear,  selectedMonth, selectedDay} = inst;

            const calendarButtonEles = dpDiv[0].querySelectorAll('.jui-datepicker-calendar tbody a, .jui-datepicker-calendar tbody span');
            const todayEle = dpDiv.find('.jui-datepicker-today a');
            const disabledEle = dpDiv.find('.jui-state-disabled');
            const otherMonthEles = dpDiv.find('.jui-datepicker-other-month');
            const monthControlBtnEles = dpDiv.find('.jui-datepicker-prev, .jui-datepicker-next');

            monthControlBtnEles.attr({'aria-hidden':'false', 'tabindex':'0'});

            const titleHead = dpDiv.find('.jui-datepicker-title');
            const headSelect = dpDiv.find('.jui-datepicker-title select');

            console.log('캘린더 접근성');

            // A11YTASK-36 disabled 날짜요소 태그변경 span => a
            const unselectable = dpDiv.find('.jui-datepicker-unselectable:not(.jui-datepicker-other-month).jui-state-disabled');
            if(unselectable?.length) {
                setTimeout(()=>{
                    unselectable.each(function(){
                        const This = $(this), unselectableAriaLabel = This?.find('span')?.attr('aria-label'),
                        unselectableDataDate = This?.find('span')?.attr('data-date'),
                        unselectableText = This?.find('span')?.text();
                        This?.find('span').remove();
                        This?.append(`<a class="jui-state-default" href="#" aria-label="${unselectableAriaLabel}" data-date="${unselectableDataDate}" aria-disabled="true" role="button">${unselectableText}</a>`);
                    });
                },200);
            }

            titleHead.attr({'aria-hidden':'false','tabindex':'0'});

            if(headSelect?.length){
                titleHead.attr({'role':'button', 'aria-hidden':'false','tabindex':'0', 'aria-hasPopup': 'true','aria-label': `${selectedYear}년 ${selectedMonth + 1}월`, 'caln-event':''});
                titleHead.find('[caln-event]').off('click.calnEvent').off('[caln-event]').removeAttr('caln-event').attr({'style':`position: absolute;top:0;left:0;width:100%;height:100%;`}); //해당 div걸린 이벤트 제거 및 스타일 깨짐 강제 css적용
            }

            headSelect.attr({'aria-hidden':'true', 'tabindex':'-1'});

            if(this?.$popup){//팝업 있을때만 실행

                const currentCalendar = this?.$popup[0]?.querySelectorAll('.ui-datepicker a');

                setTimeout(() =>{
                    isA11ySetAttr(currentCalendar, 'role', 'button');
                });
                setTimeout(() => {
                    //셀렉트 팝업내 맨 하단에 안보이는 영역 focus되는 현상 막기
                    const spinnerLiveDiv = this.$popup[0].querySelector('.input-arrow-group[data-type="dateSpinner"]');
                    if(spinnerLiveDiv){
                        spinnerLiveDiv.setAttribute('aria-hidden','true');
                        spinnerLiveDiv.setAttribute('tabindex','-1');
                    }
                },500);
            }

            if(calendarButtonEles){
                calendarButtonEles?.forEach((list) => {
                    const isActive = list.classList.contains('jui-state-active');

                    if(isActive){
                        const activeText = `${selectedYear}년 ${selectedMonth + 1}월 ${selectedDay}일 선택됨`;

                        list.setAttribute('aria-label', activeText);
                    }else{
                        //list의 텍스트 모바일에서 text값
                        const listText = `${selectedYear}년 ${selectedMonth + 1}월 ${list?.innerText || list?.innerHTML || list?.textContent || list?.text}일`;

                        list.setAttribute('aria-label', listText);
                    }
                });
            }

            disabledEle.attr({'aria-hidden':'false', 'aria-disabled':'true'});
            disabledEle.removeAttr('role');
            // disabledEle.removeAttr('tabindex');

            disabledEle.children().attr('aria-disabled','true');
            disabledEle.children().each(function(idx, td){
                const dateParts  = $(td).attr('aria-label')?.replace(/년|월|일/g,"")
                let _dataParts, dateValue;
                if (dateParts != undefined) {
                    _dataParts = dateParts.trim().split(" ");
                    dateValue = _dataParts[0]+_dataParts[1].padStart(2,"0")+_dataParts[2].padStart(2,"0");
                    $(td).attr('data-date', dateValue)
                }
            })

            if(todayEle[0]){
                todayEle[0].setAttribute('aria-current','date');
            }

            if(otherMonthEles?.length){
                //현재 날짜에서 안보이는 다른날짜들 막기
                otherMonthEles.attr({'aria-hidden':'true', 'aria-disabled':'true'});
                otherMonthEles.children().attr('aria-disabled','true');
                
            }
        } catch (error) {
            throw new Error(`func isA11yDateSpinnerKeyEvent ${error}`);
        }
    }
    isA11yCalendarInit(){
        //calendar 초기 로드시 접근성 적용
        const selectItem = this.$el[0];
        const calendarType = {
            'BUTTON': false,
            'INPUT': true,
        }

        if(calendarType[selectItem.nodeName]){
            //태그 인풋일때
            const parentDiv = selectItem.parentElement;
            const childLabel = parentDiv.querySelector('label');

            selectItem.setAttribute('aria-hidden', 'true');
            childLabel.setAttribute('aria-hidden', 'true');

            // parentDiv.setAttribute('role', 'button');
            parentDiv.setAttribute('tabindex', '0');
            parentDiv.setAttribute('title', `${childLabel?.textContent || ''} 선택`);

            if(selectItem?.value){
                parentDiv.setAttribute('aria-label', selectItem.value);
            }

            parentDiv.addEventListener('click', (e) => {
                e.preventDefault();

                $(selectItem).trigger('click');
            });

            const config = {
                subtree: false,
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['value'],
            };

            const observer = new MutationObserver(async (mutation) => {
                const { target } = mutation[0];
                parentDiv.setAttribute('aria-label',`${target?.value}`);
                parentDiv.setAttribute('title', `${childLabel?.textContent || ''} 선택`);

                $('*').blur();

                let count = 0;
                let interval = setInterval(() => {
                    if(count >= 5){
                        clearInterval(interval);
                    }
                    
                    parentDiv.focus();
                    count++;
                },100);
            });

            observer.observe(selectItem, config);
        }else{
            //태그 버튼일떄(버튼타입은 접근성 추가작업 필요 없음) 필요시 해당로직 작성
            selectItem.setAttribute('aria-haspopup', 'true');
        }
    }

    async isA11yFocusMove(){
        Popup.a11yDetctClosePopup();// 팝업 셀렉트 닫힐때 해당 로직 안타게 수정
        
        $('*').blur();

        const delay1 = new Promise((resolve) => setTimeout(resolve, 1000));

        await delay1;

        if(this?.isA11yObj?.isOpenTarget){
            if(this?.isA11yObj?.isOpenTarget[0].ariaHidden === 'true'){
                this?.isA11yObj?.isOpenTarget?.parent()?.focus();
            }else{
                this?.isA11yObj?.isOpenTarget.focus();
            }
        }
    }
    /*! e: FETASK-a11y page Calendar v.1.0.0 */
}

export default PopupCalendar;
